/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCrop = createReactComponent("crop", "IconCrop", [
  ["path", { d: "M8 5v10a1 1 0 0 0 1 1h10", key: "svg-0" }],
  ["path", { d: "M5 8h10a1 1 0 0 1 1 1v10", key: "svg-1" }]
]);

export { IconCrop as default };
//# sourceMappingURL=IconCrop.js.map
